<template>
  <section class="curation-deprecations">
    <CurationHeader />  
    <div v-if="loading">
      <Loading />
    </div>
    <div>ChemSpider ID</div>
    <div class="is-flex is-align-items-center mb-4">
      <form @submit.prevent="getRecord">        
        <input
          type="text"
          v-model="csidValue"

          style="border: 1px solid #cccccc; border-radius: 4px; padding: 0 7px; height: 40.35px; width: 400px; font-size: 1em"
        />
      </form> 
      <div>
        <button class="button ml-3" @click="getRecord">
          Get record
        </button>
      </div>
    </div>
    <template v-if="!statusMessage.message">
      <div v-if="searchedCSID && noDataFound && !loading">Sorry, no data was found for CSID: {{searchedCSID}}</div>
      <div v-else-if="searchedCSID && !noDataFound && !loading">Found data on: {{searchedCSID}}</div>
    </template>

    <div v-if="statusMessage.message" class="mt-3 is-flex is-justify-content-flex-start">
        <div :class="statusMessage.changed ? 'has-text-success' : 'has-text-danger'">
          {{ statusMessage.message }}
        </div>
    </div>
 
    <div v-if="compound.ChemSpiderId">
      <div class="is-size-4"><strong>CSID: {{ compound.ChemSpiderId }}</strong></div>
      <div class="is-size-4" v-if="compound.Title"><strong>Title: {{ compound.Title }}</strong></div>
      <div :class="compound.Deprecated ? 'disabled' : 'enabled'" style="border: 1px solid #ccdbe4; width: fit-content;" id="div-svg"></div>
    </div>
    <div v-if="compound.DeprecationDate || compound.DeprecationReason" class="mt-5 p-5" style="background-color: #fef2f6;">
      <div v-if="compound.DeprecationDate"><strong>Date of deprecation: </strong> 
        {{ new Date(compound.DeprecationDate).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })}}, {{
        new Date(compound.DeprecationDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) }} 
      </div>
      <div v-if="compound.DeprecationReason "><strong>Reason for deprecation: </strong> {{ compound.DeprecationReason }}</div>
    </div>
    <div v-if="compound" class="mt-5">
      <div>Reason for change</div>
      <div class="is-flex">
        <textarea name="reason" id="reason" v-model="reason" maxlength="400" type="text" autocomplete="off"
        style="border: 1px solid #cccccc; border-radius: 4px; padding: 0 7px; height: 100px; width: 400px; font-size: 1em">       
        </textarea>
        <div>
          <button class="button ml-3" @click="changeDeprecation" :disabled="compound.PermanentlyDeprecated">
            {{compound.Deprecated ? 'Undeprecate' : 'Deprecate' }}
          </button>
          <p class="mt-2 ml-3" style="color: #b5b5b5;" v-if="compound.PermanentlyDeprecated">
            This compound is permanently deprecated
          </p>
        </div>
      </div>
    </div>
    <div v-if="compound" class="is-size-4 mt-5">Synonyms
      <div v-if="compound.Synonyms && compound.Synonyms.length > 0" class="mt-5">
        <div v-for="synonym, index of compound.Synonyms" v-bind:key="index">
          <div class=" is-size-6 mt-3">{{ synonym.Name }}</div>
        </div>
      </div>
      <div v-else-if="compound && compound.Synonyms && compound.Synonyms.length === 0" class="is-size-6 mt-5"> No synonyms</div>
      <div v-else-if="compound && !compound.Synonyms" class="is-size-6 mt-5">No synonyms</div>
    </div>
    <div v-if="compound" class="is-size-4 mt-5">Datasources
      <div v-if="compound.Datasources && compound.Datasources.length > 0" class="mt-5">
        <div v-for="datasource, index of compound.Datasources" v-bind:key="index">
          <div class="is-size-6 mt-3">{{ datasource.ExternalUrl }}</div>
        </div>
      </div>
      <div v-else-if="compound && compound.Datasources && compound.Datasources.length === 0" class="is-size-6 mt-5"> No data sources</div>
      <div v-else-if="compound && !compound.Datasources" class="is-size-6 mt-5">No data sources</div>
    </div>
  </section>
</template>

<script>
import CurationHeader from "@/components/curation/shared/header.vue";
import { ChemspiderDataService } from "@/api";
import Loading from '@/components/shared/loading.vue';
export default {
  components: { CurationHeader, Loading },
  name: 'CurationDeprecations',    
  data() {
    return {
      csidValue: '',
      compound: '',
      svgContent: "",
      searchedCSID: 0,
      reason: '',
      noDataFound: false,
      statusMessage: {},
      changedStatus: false,
      loading: false,
    };
  },
  computed: {
    baseLink() {
      return import.meta.env.VITE_CHEMSPIDER_BASE_URL;
    },
  },
  methods: {
    async getRecord() {
      this.searchedCSID = this.csidValue;
      this.noDataFound = false;
      this.loading = true;
      if (!this.changedStatus) this.statusMessage = {};
      this.changedStatus = false;
      const compoundJson = import.meta.env.DEV
        ? `/dummy-data/compound.json`
        : `${this.baseLink}/compound-data/${this.csidValue}/compound.json`;
      try {
        const response = await fetch(compoundJson);
        if (!response.ok) {          
          this.compound = '';
          this.svgContent =  "";
          this.noDataFound = true;
          this.loading = false;
          throw new Error('Cannot load compound.json'); 
        } else {
          const json = await response.json();
          this.compound = json || [];
          this.loadRdKitMol();
          this.loading = false;
        }
      } catch (err) {
        console.error("Error loading compound:", err);
        this.compound = '';
        this.svgContent =  "";
        this.loading = false;
      }
      
    },
    async uploadRdKitScript() {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = "/rdkit/RDKit_minimal.js";
        script.type = "application/javascript";
        script.defer = true;
        script.async = true;

        script.onload = () => resolve();
        script.onerror = (e) => reject(e);

        document.head.appendChild(script);
      });
    },
    async loadRdKitMol() {
      // molfile for RDKit:
      const url =
        import.meta.env.DEV
          ? `/dummy-data/2157.mol`
          : `${this.baseLink}/compound-data/${this.csidValue}/${this.csidValue}.mol`
      try {
        const response = await fetch(url);
        if (!response.ok) {
          // Handles http error (404 or 500)
          this.svgContent = "";
          let dest = document.getElementById("div-svg");    
          if (dest) dest.innerHTML = '';  
          return;
        }
        const content = await response.text();
        let cutcontent = content.split("M  END")[0] + "M  END";
        let mol = window.RDKit.get_mol(cutcontent);
        if (mol) {
            // RDKit Builds SVG
            let dest = document.getElementById("div-svg");
            let mdetails = {};
            mdetails['width'] = 200;
            mdetails['height'] = 200;         
            mdetails['includeRadicals'] = false;
            let svg = mol.get_svg_with_highlights(JSON.stringify(mdetails));
            // Stores the SVG content in the ref
            this.svgContent = svg;
            if (dest) dest.innerHTML = svg;          
        }
        else {
          this.svgContent =  "";
        }
      } catch (error) {
        console.error("Error fetching compound data:", error);
      }
    }, 
    async changeDeprecation() {
      this.loading = true
      try {
          let response
          response = await ChemspiderDataService.changeDeprecation(this.searchedCSID, !this.compound.Deprecated, this.reason);
          if (response.Data != null) {
            this.csidValue = this.searchedCSID;
            this.reason = '';
            if (!this.compound.Deprecated) this.statusMessage = {message: 'Deprecation was successful', changed: true}
            if (this.compound.Deprecated) this.statusMessage = {message: 'Undeprecation was successful', changed: true}
            this.changedStatus = true
            this.getRecord();
          } else {
            console.error('error trying to deprecate')
            if (!this.compound.Deprecated) this.statusMessage = {message: 'Deprecation failed', changed: false}
            if (this.compound.Deprecated) this.statusMessage = {message: 'Undeprecation was failed', changed: false}
          }
      } catch (error) {
            console.error(`Error changing deprecation ${this.searchedCSID}:`, error);
      }
      this.loading = false
    }
  },
  async mounted() {
    await this.uploadRdKitScript();

    if (!window.RDKit) {
      try {
        const RDKit = await window.initRDKitModule();
        window.RDKit = RDKit;
      } catch (e) {
        console.error(e);
      }
    }
  }
};
</script>

<style lang="scss" scoped>

.disabled {
  opacity: .3;
  pointer-events: none;
}

.enabled {
  opacity: 1;
  pointer-events: auto;
}

textarea::-webkit-resizer {
  display: none;
}

textarea {
  resize: none;
}
</style>

  